import { vservice } from '@niknevis/vue-modules'
import { AdminDepositBankAccountRoute } from '@/modules/deposit-bank-account/routes/admin-deposit-bank-account.route'
import { DepositBankAccountRequestModel } from '@/modules/deposit-bank-account/models/deposit-bank-account-request.model'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'

@vservice()
export class AdminDepositBankAccountService {
  constructor(
    private readonly routes: AdminDepositBankAccountRoute
  ) {
  }

  storeDepositBankAccount(data: DepositBankAccountRequestModel) {
    return Inertia.post(
      this.routes.store(),
      data
    )
  }

  updateDepositBankAccount(accountId: number, data: DepositBankAccountRequestModel) {
    return Inertia.put(
      this.routes.update(accountId),
      data
    )
  }
}
